// react
import React, { useState, useContext } from 'react';
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";

// @material-ui/core components
import Tooltip from "@material-ui/core/Tooltip";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import GatewayForm from "./GatewayForm";

// services
import { useGetApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';

const useStyles = makeStyles(styles);

export default function Gateway({ history, callUpdateScrollTOP }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);

    const [showFormView, setshowFormView] = useState(false);
    const [item, setItem] = useState({});

    const [{ list, isLoadingList, isErrorGetList }, setListAtualiza] = useGetApi("gateways");

    const handleView = (resetItem, currentItem) => {
        if (resetItem) {
            setItem(null);
        }

        const show = !showFormView;
        setshowFormView(show);
        if (callUpdateScrollTOP) callUpdateScrollTOP();

        if (!currentItem) return;

        const verifyExists = list && list.filter(obj => obj.gatewayId === currentItem.gatewayId);

        if (verifyExists && verifyExists.length > 0) {
            const updateList = list.map(l => (l.gatewayId === currentItem.gatewayId ? currentItem : l));
            setListAtualiza(updateList);
        } else {
            const addItemList = list ? [...list, currentItem] : [currentItem];
            setListAtualiza(addItemList);
        }
    };

    const handleEdit = row => {
        setItem(row);
        handleView(false);
    };

    const columnsProp = [
        {
            Header: "ID",
            accessor: "gatewayId",
            width: 80
        },
        {
            Header: "Descrição",
            accessor: "descricao",
        },
        {
            Header: "Tipo",
            accessor: "tipo",
        },
        {
            Header: "URL",
            accessor: "url",
        },
        {
            Header: t('label.status'),
            Cell: row => (<span> {row.original.ativo ? t('label.active') : t('label.inactive')} </span>),
            filterable: false,
            width: 100
        }
    ];

    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    <Button
                        justIcon
                        round
                        simple
                        color="success"
                        className="edit"
                        onClick={() => handleEdit(row.original)}
                    >
                        <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }}>
                            <Edit />
                        </Tooltip>
                    </Button>
                </div>
            ),
            sortable: false,
            filterable: false,
            width: 100
        }
    ];

    const columns = [...columnsProp, ...columnsAcao];

    return (
        <div>
            {!showFormView &&
                <GridContainer>
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <Assignment />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>Lista de Gateways</h4>
                                <div style={{ float: 'right' }}>
                                    <Button color="success" onClick={() => handleView(true, null)} disabled={isLoadingList}>
                                        Adicionar
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                                <ReactTable
                                    loading={isLoadingList}
                                    data={list || []}
                                    filterable
                                    defaultFilterMethod={noCaseSensitive}
                                    columns={columns}
                                    defaultPageSize={10}
                                    minRows={5}
                                    showPaginationBottom={true}
                                    className="-striped -highlight"
                                    previousText={t('button.previous')}
                                    nextText={t('button.next')}
                                    loadingText={t('label.loading') + "..."}
                                    noDataText={t('information_message.no_records_found') + "!"}
                                    pageText={t('label.page')}
                                    ofText={t('label.of')}
                                    rowsText={t('label.rows')}
                                />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            }

            {showFormView &&
                <GatewayForm item={item} handleView={handleView} history={history} />
            }
        </div>
    );
}
